export const updateUserData = data => {
	return {
		...data,
	};
};
